import ActionButtons from "./ActionButtons";

export default function ActionsColumn({
  columns,
  onPodrobnostiActionClick,
  onDeleteActionClick,
  canDelete,
  onPovezavaActionClick,
}) {
  columns.push({
    header: "Akcije",
    id: "actions",
    cell: (info) => (
      <ActionButtons
        row={info.row}
        onPodrobnostiClick={onPodrobnostiActionClick}
        onDeleteClick={onDeleteActionClick}
        canDelete={canDelete}
        onPovezavaClick={onPovezavaActionClick}
      />
    ),

    disableSortBy: true,
    disableFilters: true,
  });
}
